export default "skymp5-front/feb2916690255e07940e64c81fe91add.gif";